import * as React from 'react';
import {
	StackCompat as Stack,
	IStackStyles,
	IStackTokens,
	IStackItemStyles,
	ImageCompat as Image,
	LinkCompat as Link,
	useTheme,
	Theme,
	IImageStyles,
} from 'components/FluentUICompat';
import PorscheLogo from '../../../assets/porsche.svg';
import TraceLogo from '../../../assets/trace.svg';
import {TextSearchBar} from 'components/TextSearchBar';
import {NavigationRight} from './NavigationRight';
import {getConfig} from 'config';
import {isDevEnvironment, isTestEnvironment} from './environmentUtils'; 

const config = getConfig();

export const Navigation = () => {
	const theme = useTheme();
	const {
		horizontalGapStackTokens,
		logoLinkStyles,
		porscheLogoStyles,
		traceLogoStyles,
		stackStyles,
	} = getStyles(theme);

	return (
		<Stack
			horizontal
			disableShrink
			horizontalAlign='space-between'
			styles={stackStyles}
			tokens={horizontalGapStackTokens}
		>
			<Stack.Item align='start'>
				<Link href='/' styles={logoLinkStyles}>
					<Image src={PorscheLogo} alt='Porsche' styles={porscheLogoStyles} />
					<Image src={TraceLogo} alt='Trace' styles={traceLogoStyles} />
					{renderEnvironmentItem(theme)}
				</Link>
			</Stack.Item>
			<Stack.Item>
				<TextSearchBar />
			</Stack.Item>
			<NavigationRight />
		</Stack>
	);
};

const getStyles = (theme: Theme) => ({
	stackStyles: {
		root: {
			background: getBackgroundColor(theme),
			padding: 10,
			height: 70,
		},
	} as IStackStyles,

	horizontalGapStackTokens: {
		padding: 10,
	} as IStackTokens,

	testEnv: {
		root: {
			fontWeight: 'bold',
			paddingLeft: 15,
			color: theme.palette.white,
		},
	} as IStackItemStyles,

	logoLinkStyles: {
		root: {
			color: theme.palette.white,
			padding: 5,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			selectors: {
				':hover': {
					textDecoration: 'none',
				},
			},
		},
	} as IStackItemStyles,

	porscheLogoStyles: {
		root: {
			marginRight: 10,
			width: 31.11,
			height: 40,
		},
		image: {
			width: 31.11,
			height: 40,
		},
	} as IImageStyles,

	traceLogoStyles: {
		root: {
			marginRight: 10,
			marginLeft: 10,
			width: 95.77,
			height: 20,
		},
		image: {
			width: 95.77,
			height: 20,
		},
	} as IImageStyles,
});

const getBackgroundColor = (theme: Theme) => {
	if (isTestEnvironment()) {
		return theme.palette.green;
	}

	if (isDevEnvironment()) {
		return theme.palette.orange;
	}

	return theme.palette.neutralPrimary;
};

const renderEnvironmentItem = (theme: Theme) => {
	const {testEnv} = getStyles(theme);

	if (isTestEnvironment()) {
		return <Stack.Item styles={testEnv}>Testumgebung</Stack.Item>;
	}

	if (isDevEnvironment()) {
		return <Stack.Item styles={testEnv}>DEV</Stack.Item>;
	}

	return null;
};

export {isTestEnvironment, isDevEnvironment} from './environmentUtils';
